var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlertTriangleFilledIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.41211 11.5352H11.5879C12.543 11.5352 13.1816 10.8027 13.1816 9.94141C13.1816 9.67773 13.1113 9.4082 12.9707 9.15625L8.37695 0.935547C8.06641 0.378906 7.53906 0.115234 7 0.115234C6.46094 0.115234 5.92773 0.384766 5.62305 0.935547L1.0293 9.16211C0.888672 9.4082 0.818359 9.67773 0.818359 9.94141C0.818359 10.8027 1.45703 11.5352 2.41211 11.5352ZM7.00586 7.3457C6.5957 7.3457 6.35547 7.11719 6.33203 6.70117L6.23828 4.16992C6.2207 3.72461 6.53125 3.42578 7 3.42578C7.46289 3.42578 7.78516 3.73047 7.76758 4.16992L7.66797 6.69531C7.65039 7.11719 7.41016 7.3457 7.00586 7.3457ZM7.00586 9.46094C6.54297 9.46094 6.17969 9.16797 6.17969 8.7168C6.17969 8.27734 6.53711 7.97852 7.00586 7.97852C7.47461 7.97852 7.83203 8.27734 7.83203 8.7168C7.83203 9.16797 7.47461 9.46094 7.00586 9.46094Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTriangleFilledIcon);
export default __webpack_public_path__ + "static/media/alertTriangleFilledIcon.1c0439e5.svg";
export { ForwardRef as ReactComponent };